// kfe-tile-grid.js — square-tile image grid for L2B.
//
// PORT TARGET: L2B grid in L2BExerciseScreen.cs (cell size = min(cellW, cellH))
// and the iOS L2B image grid.
//
// Emits: "pick" with detail = { mmuId } when a tile is tapped.
// Tiles are always square (per CLAUDE.md). ALWAYS 4 per row across viewports —
// matches iOS canon (Rule #9). A prior responsive media query collapsed the
// grid to 3 columns at viewport widths ≤ 600px (mobile), producing a 3+3+2
// layout on phones; Chris flagged this as a canon divergence on his 2026-06-28
// iPhone walk (L2B canon is 4×2 always). The media query has been removed;
// tiles shrink to fit four columns on narrow viewports rather than reflow.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";
import { resolveImage } from "../data/media-paths.js";

export class KFETileGrid extends KFEComponent {
  static props = ["items"];
  static styles = `
    :host { display: block; }
    .grid { display: grid; gap: 0.5rem;
            grid-template-columns: repeat(4, 1fr); }
    /* White tile background: L2B images are transparent-PNG line drawings
       designed for white-paper rendering. On the dark theme surface they're
       invisible; the shared --kfe-l2b-image-bg token restores the canonical
       iOS white image cell (Brief 061). */
    .tile { aspect-ratio: 1 / 1; background: var(--kfe-l2b-image-bg);
            border: 1px solid var(--kfe-border); border-radius: 8px;
            display: flex; align-items: center; justify-content: center;
            overflow: hidden; cursor: pointer; padding: 0; }
    .tile img { width: 100%; height: 100%; object-fit: contain; }
    .tile.no-image { font-size: 0.85rem; padding: 0.5rem; text-align: center; }
  `;

  async onConnected() {
    /** @type {{ items?: any[] }} */
    const self = /** @type {any} */ (this);
    if (!self.items) return;
    /** @type {Record<number,string>} */ this._urls = {};
    for (const m of self.items) {
      const url = await resolveImage(m);
      if (url) this._urls[m.mmuId] = url;
    }
    this._scheduleRender();
  }

  render() {
    const items = /** @type {any[]} */ (/** @type {any} */ (this).items) ?? [];
    return html`
      <div class="grid">
        ${items.map((m) => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "tile l2b-image-container" + (this._urls?.[m.mmuId] ? "" : " no-image");
          if (this._urls?.[m.mmuId]) {
            const img = document.createElement("img");
            img.src = this._urls[m.mmuId];
            img.alt = m.phrase;
            img.loading = "lazy";
            btn.appendChild(img);
          } else {
            btn.textContent = m.phrase;
          }
          btn.addEventListener("click", () => this.emit("pick", { mmuId: m.mmuId }));
          return btn;
        })}
      </div>
    `;
  }
}
